import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { usePopupQuery } from "../../../../api/queries/popupQueries";
import { ModalBtn } from "../../../../components/modal/ModalBtn";
import { ProductPopup } from "../../../../components/product-detail/ProductPopup";
import BookingService from "../../../../services/bookingService";
import { ProductModalIntroText } from "../../../Pass/components/SelectOptionSection/SelectProductModal";
import { Trans } from "react-i18next";
import { AppInfo } from "../../../../utils/app-info";
import { icAsset } from "../../../../components/image/image-src";

interface ReceiveTicketModalProps {
  id: number;
  bookNo: string | number;
  bookingDetailId: string | number;
  isOpen?: boolean;
  onSubmit?: () => void;
  onClose?: () => void;
  product?: ProductDetailResponse;
}

const ReceiveTicketModal: React.FC<ReceiveTicketModalProps> = ({
  id,
  bookNo,
  bookingDetailId,
  isOpen,
  onClose,
  onSubmit,
  product,
}) => {
  const popupQuery = usePopupQuery(product?.deliveryMethod ?? "");
  const formatNewlineContent = (content: string) => {
    if (!content) return "";
    // Replace newlines with <br /> and return as JSX
    const parts = content.split("\n");
    return parts.map((part, idx) =>
      idx === 0 ? part : [<br key={idx} />, part],
    );
  };
  const { t } = useTranslation();
  const [receiveSuccess, setReceiveSuccess] = useState(false);
  const [isEnoughTicket, setIsEnoughTicket] = useState(false);
  const mutation = useMutation(
    async () => {
      return await BookingService.receiveTickeInfo(
        bookNo,
        Number(bookingDetailId),
      );
    },
    {
      onSuccess: (data) => {
        setIsEnoughTicket(data);
        setReceiveSuccess(true);
      },
      onError: (error: any) => {
        alert("Error: " + error.message);
      },
    },
  );

  // const {
  //   data,
  //   isLoading: queryIsLoading,
  //   refetch,
  //   error,
  // } = useQuery<ReceiveTicketForm | undefined, Error>(
  //   ["receiveTicketForm", id],
  //   async () => {
  //     return (await BookingService.getReceiveInfo(
  //       bookingDetailId,
  //       Number(id),
  //     )) as ReceiveTicketForm;
  //   },
  //   {
  //     enabled: isOpen,
  //     onSuccess: (result) => {},
  //   },
  // );

  const handleSubmit = () => {
    mutation.mutate();
  };

  const handleOk = () => {
    // setReceiveSuccess(false);
    onSubmit && onSubmit();
    onClose?.();
    window.location.reload();
  };

  const handleClose = () => {
    onClose && onClose();
  };

  // useEffect(() => {
  //   if (isOpen) {
  //     refetch();
  //   }
  // }, [isOpen, id, refetch]);

  // if (queryIsLoading) {
  //   return (
  //     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  //       <div className="relative w-full max-w-3xl rounded-[1rem] border border-[#D7DCE3] bg-white shadow-lg">
  //         <div className="p-6"></div>
  //       </div>
  //     </div>
  //   );
  // }

  // if (error) {
  //   return (
  //     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  //       <div className="relative w-full max-w-3xl rounded-[1rem] border border-[#D7DCE3] bg-white shadow-lg">
  //         <div className="p-6">
  //           {t("Error: ")}
  //           {error.message}
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }
  const renderReceiveForm = () => {
    return (
      <ProductPopup product={product}>
        {/* Body */}
        <>
          <ProductModalIntroText product={product} showViewProduct={true} />
          {!!popupQuery?.data?.contentReceive && (
            <div className="border-t border-[#DCDCDC] pt-5">
              <div className="flex items-center leading-[26px] text-[#DA3838]">
                {formatNewlineContent(t(popupQuery?.data?.contentReceive))}
              </div>
            </div>
          )}
        </>
        {/* Footer */}
        <>
          <div className="grid grid-cols-2 place-items-center gap-4 py-5">
            {/* flex justify-end gap-4 py-5 */}
            <ModalBtn opts={["cancel", "md"]} onClick={handleClose}>
              {t("Close")}
            </ModalBtn>
            <ModalBtn
              onClick={handleSubmit}
              opts={["primary", "md", mutation.isLoading && "loading"]}
            >
              {t("Receive Ticket")}
            </ModalBtn>
          </div>
        </>
      </ProductPopup>
    );
  };

  const renderModal = () => {
    const href = AppInfo.get("kakao");
    if (receiveSuccess) {
      if (isEnoughTicket) {
        return (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative w-[22.5rem] max-w-3xl rounded-[1rem] border border-[#D7DCE3] bg-white shadow-lg">
              <div className="p-6 text-center">
                <img
                  src={icAsset("../../../../assets/icons/success-icon.svg")}
                  className="mx-auto mb-6 h-12 w-12"
                  alt=""
                />
                <h2 className="mb-2 text-[1.125rem] font-semibold leading-[1.6875rem] text-[#232323]">
                  {/* {t("Your ticket has been received.")} */}
                  {t("Request successful")}
                </h2>
                <p className="mb-6 text-[0.875rem] font-normal leading-[1.375rem] text-[#5E6D77]">
                  {t(
                    "If you have trouble accessing your ticket, please contact Tamis Customer Service",
                  )}
                </p>

                <button
                  onClick={handleOk}
                  className={`${
                    !mutation.isLoading
                      ? "bg-primary text-[#232323]"
                      : "bg-[#DCDCDC] text-white"
                  } w-full rounded-[3.4375rem] py-[0.8125rem] text-base font-semibold leading-[1.25rem] text-[#232323]`}
                >
                  {t("Ok")}
                </button>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative w-[22.5rem] max-w-3xl rounded-[1rem] border border-[#D7DCE3] bg-white shadow-lg">
              <div className="p-6 text-center">
                <img
                  src="../../../assets/icons/warning-yellow.svg"
                  className="mx-auto mb-6 h-12 w-12"
                  alt=""
                />
                <h2 className="mb-2 text-[1.125rem] font-semibold leading-[1.6875rem] text-[#232323]">
                  {t("Tickets are being prepared.")}
                </h2>
                <p className="mb-6 text-[0.875rem] font-normal leading-[1.375rem] text-[#5E6D77]">
                  {/* {t(
                    "Please contact the Tamis KakaoTalk Customer Center and we will assist you right away.",
                  )} */}

                  <Trans i18nKey="Please contact the Tamis KakaoTalk Customer Center and we will assist you right away.">
                    Please contact the{" "}
                    <a
                      href={href}
                      target="_blank"
                      rel="noreferrer"
                      className="underline"
                    >
                      Tamis KakaoTalk
                    </a>{" "}
                    Customer Center and we will assist you right away.
                  </Trans>
                </p>

                <button
                  onClick={handleOk}
                  className={`${
                    !mutation.isLoading
                      ? "bg-primary text-[#232323]"
                      : "bg-[#DCDCDC] text-white"
                  } w-full rounded-[3.4375rem] py-[0.8125rem] text-base font-semibold leading-[1.25rem] text-[#232323]`}
                >
                  {t("Ok")}
                </button>
              </div>
            </div>
          </div>
        );
      }
    }
    return renderReceiveForm();
  };

  return <>{isOpen && renderModal()}</>;
};

export default ReceiveTicketModal;
